/**
 * Ingest Tab - Wrapper for IngestDataStep component
 * Populates the provisioned database with ERC-8004 agent data from the subgraph
 */

import { IngestDataStep } from '../steps/IngestDataStep';
import type { TenantCredentials, IngestionStats } from '@/types/database';

interface IngestTabProps {
  credentials: TenantCredentials | null;
  onComplete?: (stats: IngestionStats) => void;
}

export function IngestTab({ credentials, onComplete }: IngestTabProps) {
  if (!credentials) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="text-center py-12">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Database Not Provisioned
          </h3>
          <p className="text-gray-600">
            Please provision a database first using the "Provision Database" tab.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Database Info Banner */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 className="text-sm font-medium text-blue-900 mb-1">
          Database Ready for Ingestion
        </h3>
        <p className="text-sm text-blue-700">
          Tenant ID: <code className="bg-blue-100 px-1 rounded">{credentials.tenant_id}</code>
        </p>
        <p className="text-sm text-blue-700 mt-1">
          Tier: {credentials.tier} ({credentials.database_mode})
        </p>
      </div>

      {/* Ingest Data Step */}
      <IngestDataStep
        credentials={credentials}
        onComplete={(stats) => {
          console.log('Ingestion complete:', stats);
          onComplete?.(stats);
        }}
      />
    </div>
  );
}
